import { SearchTerm } from "./SearchTerm";

const EnrolmentAuditSearch: SearchTerm[] = [
    {
        heading: "Operator",
        accessor: "operator",
        searchOnName: "auditSession.asUserLoginName",
        translationKey: "operator"
    }
];

export default EnrolmentAuditSearch;
